var map = {
	"./decidim/avatar-multiuser.png": 26562,
	"./decidim/brands/google.svg": 49229,
	"./decidim/cc-badge.png": 30076,
	"./decidim/decidim-logo.svg": 28688,
	"./decidim/default-avatar.svg": 63752,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 98516,
	"./decidim/icons.svg": 86595,
	"./decidim/pattern.png": 62676,
	"./decidim/placeholder-card-g.svg": 57473,
	"./decidim/placeholder-card-l.svg": 11594,
	"./decidim/placeholder.jpg": 29785,
	"./decidim/remixicon.symbol.svg": 49997,
	"./decidim/vendor/leaflet/layers-2x.png": 83244,
	"./decidim/vendor/leaflet/layers.png": 97307,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 63158,
	"./decidim/vendor/leaflet/marker-icon.png": 71501,
	"./decidim/vendor/leaflet/marker-shadow.png": 20994,
	"./decidim/vendor/social-share-button/douban.svg": 22332,
	"./decidim/vendor/social-share-button/email.svg": 77209,
	"./decidim/vendor/social-share-button/facebook.svg": 71119,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 1585,
	"./decidim/vendor/social-share-button/hacker_news.svg": 36633,
	"./decidim/vendor/social-share-button/linkedin.svg": 54681,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 49050,
	"./decidim/vendor/social-share-button/pinterest.svg": 51871,
	"./decidim/vendor/social-share-button/reddit.svg": 46339,
	"./decidim/vendor/social-share-button/telegram.svg": 64278,
	"./decidim/vendor/social-share-button/tumblr.svg": 90837,
	"./decidim/vendor/social-share-button/twitter.svg": 65576,
	"./decidim/vendor/social-share-button/vkontakte.svg": 71334,
	"./decidim/vendor/social-share-button/wechat.svg": 24449,
	"./decidim/vendor/social-share-button/whatsapp.svg": 66889,
	"./decidim/vendor/social-share-button/x.svg": 97761,
	"./decidim/vendor/social-share-button/xing.svg": 54511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66135;